<template>
  <div v-frag class="fadeIn">
    <CardIeaAppMain>
      <v-container fluid class="pa-4">
        <!-- HEADER -->
        <v-row align="center" class="mb-6">
          <v-col cols="12">
            <h1 class="text-h4 font-weight-bold bce-text-gradient">Inscripciones a Exámenes</h1>
            <p class="grey--text text--darken-1">Consulta las mesas disponibles y regístrate para tus próximos exámenes finales.</p>
          </v-col>
        </v-row>

        <div v-if="loading" class="text-center pa-10">
          <v-progress-circular indeterminate color="#E50050" size="48"></v-progress-circular>
          <div class="mt-4 grey--text">Cargando mesas de examen...</div>
        </div>

        <div v-else>
          <!-- COUNTER ALERT -->
          <v-alert
            v-if="data && data.cantidad > 0"
            border="left"
            colored-border
            color="#E50050"
            elevation="2"
            class="rounded-xl mb-8 bce-alert-red"
          >
            <div class="d-flex align-center">
              <v-icon color="#E50050" class="mr-3">mdi-information-outline</v-icon>
              <span class="text-subtitle-1 font-weight-bold">
                Tienes <span class="bce-red-text font-weight-black">{{ data.cantidad }}</span> materias disponibles para inscripción.
              </span>
            </div>
          </v-alert>

          <v-alert
            v-else
            border="left"
            colored-border
            color="grey darken-1"
            elevation="2"
            class="rounded-xl mb-8"
          >
            <div class="d-flex align-center">
              <v-icon color="grey darken-1" class="mr-3">mdi-calendar-remove</v-icon>
              <span class="text-subtitle-1">No hay mesas disponibles actualmente para tus materias.</span>
            </div>
          </v-alert>

          <!-- EXAM TABLES -->
          <v-row v-if="data && data.data">
            <v-col v-for="(examenMesa, examenMesaKey) in data.data" :key="examenMesaKey" cols="12">
              <v-card class="rounded-xl elevation-3 overflow-hidden mb-6 bce-mesa-card">
                <div class="bce-mesa-header pa-4 white--text">
                  <div class="d-flex align-center">
                    <v-icon color="white" class="mr-2">mdi-calendar-star</v-icon>
                    <span class="text-h6 font-weight-bold">{{ examenMesa.curso.nombre }}</span>
                  </div>
                </div>

                <v-card-text class="pa-0">
                  <v-simple-table class="bce-premium-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left font-weight-bold grey--text text--darken-2">Materia</th>
                          <th class="text-center font-weight-bold grey--text text--darken-2" style="width: 220px;">Estado / Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(planData, planKey) in examenMesa.curso.plan_de_estudio_v2" :key="planKey" class="bce-tr-hover">
                          <td class="font-weight-medium py-4">{{ planData.Materia }}</td>
                          <td class="text-center py-4">
                            <!-- STATUS ACTIONS -->
                            <v-btn v-if="planData.tipo == 0" disabled text small class="grey--text">Sin Mesa</v-btn>
                            
                            <v-btn 
                              v-else-if="planData.tipo == 1" 
                              @click="inscripcionMesaExamen(planData.IDStB, examenMesa.id)" 
                              color="#E50050" 
                              dark 
                              depressed
                              class="rounded-lg text-none px-6"
                            >
                              Inscribirse
                            </v-btn>

                            <div v-else-if="planData.tipo == 2" class="d-flex flex-column align-center">
                              <v-chip color="orange darken-4" outline small label class="font-weight-bold mb-1">
                                Pendiente de Validación
                              </v-chip>
                              <v-btn @click="cancelarInscripcionMesaExamen(planData.examen_inscipcion_alumno[0].id_validacion)" x-small text color="error" class="text-none mt-1">
                                Cancelar trámite
                              </v-btn>
                            </div>

                            <v-btn 
                              v-else-if="planData.tipo == 3" 
                              @click="linkPrueba(planData.examen_asociado.id_testpyr)" 
                              color="#1976D2" 
                              outlined 
                              class="rounded-lg text-none font-weight-bold"
                            >
                              Rendir Examen
                            </v-btn>

                            <v-chip v-else-if="planData.tipo == 4" color="error" dark label small class="font-weight-bold">
                              Rechazado
                            </v-chip>

                            <v-chip v-else-if="planData.tipo == 5" color="success" dark label small class="font-weight-bold">
                              Confirmado
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain.vue";

export default {
  name: "InscripcionesExamenes",
  components: { CardIeaAppMain },
  data() {
    return { 
      data: null, 
      loading: true 
    }
  },
  mounted() { 
    this.mesaDeExamen(); 
  },
  methods: {
    async mesaDeExamen() {
      this.loading = true;
      try {
        const res = await this.$API.get({ url: "examen/mesas", data: {} });
        this.data = res;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async inscripcionMesaExamen(examen, mesa) {
      try {
        await this.$API.post({
          url: "examen/mesas-inscripcion",
          data: { materia_id: examen, examenMesa_id: mesa }
        });
        this.mesaDeExamen();
      } catch (e) { console.error(e); }
    },
    async cancelarInscripcionMesaExamen(id) {
      try {
        await this.$API.post({
          url: "examen/cancelar-inscripcion",
          data: { id: id }
        });
        this.mesaDeExamen();
      } catch (e) { console.error(e); }
    },
    linkPrueba(id) {
       this.$router.push({ name: 'examen', params: { test: id } });
    }
  }
}
</script>

<style scoped>
.bce-text-gradient {
  background: linear-gradient(45deg, #1a237e 30%, #E50050 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bce-alert-red {
  background-color: #fff5f5 !important;
}

.bce-red-text {
  color: #E50050;
}

.bce-mesa-card {
  transition: all 0.3s;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.bce-mesa-header {
  background: linear-gradient(135deg, #2c3e50 0%, #1a237e 100%);
}

.bce-premium-table thead th {
  background-color: #f8f9fa !important;
  height: 50px !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.5px;
}

.bce-tr-hover:hover {
  background-color: #fffafa;
}

.fadeIn { 
  animation: fadeIn 0.4s ease-in-out; 
}

@keyframes fadeIn { 
  from { opacity: 0; transform: translateY(10px); } 
  to { opacity: 1; transform: translateY(0); } 
}
</style>
